import { FC, PropsWithChildren, createContext, useContext, useRef, useState } from 'react';

type PhaseInfo = Readonly<{ phaseWidth: number; acitvitiesAmount: number }>;

type ContextType = Readonly<{
	content: Map<string, PhaseInfo>;
	isVerticalScrollEnabled: boolean;
	setIsVerticalScrollEnabled: (arg: boolean) => void;
	setContent: (key: string, value: PhaseInfo) => void;
	clearContent: () => void;
}>;

const HorizontalScrollMapContext = createContext<ContextType>({
	content: new Map(),
	isVerticalScrollEnabled: true,
	setIsVerticalScrollEnabled: () => {},
	setContent: () => {},
	clearContent: () => {},
});

export const HSMCProvider: FC<PropsWithChildren> = ({ children }) => {
	const { current: content } = useRef(new Map<string, PhaseInfo>());
	const [isVerticalScrollEnabled, setIsVerticalScrollEnabled] = useState(true);

	return (
		<HorizontalScrollMapContext.Provider
			value={{
				content,
				isVerticalScrollEnabled,
				setIsVerticalScrollEnabled,
				setContent: (key, value) => content.set(key, value),
				clearContent: () => content.clear(),
			}}
		>
			{children}
		</HorizontalScrollMapContext.Provider>
	);
};

export const useHSMContext = (): ContextType => useContext(HorizontalScrollMapContext);
